import * as React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";

const SliderTooltip = ({ children, style, htmlElementRef, ...props }) => (
  <div
    role="tooltip"
    className={gatherClasses(props, "oui-slider-tooltip")}
    style={style}
    ref={htmlElementRef}
  >
    <div className="oui-slider-tooltip-arrow" />
    <div className="oui-slider-tooltip-inner">{children}</div>
  </div>
);

SliderTooltip.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  htmlElementRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ]),
  style: PropTypes.object
};

SliderTooltip.defaultProps = {
  className: null,
  htmlElementRef: null,
  style: null
};

SliderTooltip.displayName = "OrionSliderTooltip";

export default SliderTooltip;
